import { motion } from "framer-motion";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import { useEffect, useState } from "react";
import { onAuthStateChanged, signOut } from "firebase/auth";
import { auth } from "./firebase";
import Login from "./components/Login";
// import SignUp from "./components/SignUp";
import Main from "./components/Main";
import Dashboard from "./components/Dashboard";
import Admin from "./components/Admin";
import ProtectedRoute from "./components/ProtectedRoute";

function LoadingScreen() {
  return (
    <div className="flex h-screen justify-center items-center bg-gray-900">
      <motion.div
        animate={{ rotate: 360 }}
        transition={{ repeat: Infinity, duration: 1, ease: "linear" }}
        className="w-12 h-12 border-4 border-t-4 border-gray-100 rounded-full"
      />
    </div>
  );
}

function App() {
  const [user, setUser] = useState(null);
  const [checkingAuth, setCheckingAuth] = useState(true);

  useEffect(() => {
    // Sign out user on refresh
    signOut(auth).then(() => {
      setUser(null);
      setCheckingAuth(false); // Done checking auth state
    });

    const unsubscribe = onAuthStateChanged(auth, (currentUser) => {
      setUser(currentUser);
      setCheckingAuth(false); // Done checking auth state
    });

    return () => unsubscribe();
  }, []);

  if (checkingAuth) {
    return <LoadingScreen />;
  }

  return (
    <Router>
      <Routes>
        <Route path="/" element={<Login />} />
        {/* <Route path="/signup" element={<SignUp />} /> */}
        <Route element={<ProtectedRoute user={user} />}>
          <Route path="/admin" element={<Admin />} />
          <Route path="/main" element={<Main />} />
          <Route path="/dashboard" element={<Dashboard />} />
        </Route>
        {/* Redirect any unknown routes to home (login page) */}
        <Route path="*" element={<Navigate to="/" />} />
      </Routes>
    </Router>
  );
}

export default App;
